
export class StylingModel {
/**
 * Classes names
 */
class?: string;
/**
 * TODO: describe
 */
dynamicClass?: string;
/**
 * TODO: describe
 */
condition?: string;
/**
 * TODO: describe
 */
value?: string;
/**
 * TODO: describe
 */
style?: string;
/**
 * AM color name. Can be one of: primary, accent, warn.
 */
themeColor?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

function StylingModel_tsickle_Closure_declarations() {
/**
 * Classes names
 * @type {?}
 */
StylingModel.prototype.class;
/**
 * TODO: describe
 * @type {?}
 */
StylingModel.prototype.dynamicClass;
/**
 * TODO: describe
 * @type {?}
 */
StylingModel.prototype.condition;
/**
 * TODO: describe
 * @type {?}
 */
StylingModel.prototype.value;
/**
 * TODO: describe
 * @type {?}
 */
StylingModel.prototype.style;
/**
 * AM color name. Can be one of: primary, accent, warn.
 * @type {?}
 */
StylingModel.prototype.themeColor;
}

